import { VALIDATION_STATES } from '../../../core/const/fields.js';

const parseDefaultValue = (value) => {
  if (typeof value === 'number') {
    return value.toString();
  }
  return value;
};

export default {
  props: {
    fieldId: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: 'text',
    },
    prefixId: {
      type: String,
      required: false,
    },
    prefixName: {
      type: String,
      required: false,
    },
    prefix: {
      type: [String, Number],
    },
    prefixType: {
      type: String,
      default: 'text',
    },
    maxlength: {
      type: Number,
      required: false,
    },
    label: {
      type: String,
      required: true,
    },
    errorMessage: {
      type: String,
      required: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    validationState: {
      type: String,
      default: VALIDATION_STATES.unprocessed,
    },
    value: {
      type: [String, Number],
    },
    onChange: {
      type: Function,
      required: true,
    },
    onInstantChange: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      isFocused: false,
      internalValue: parseDefaultValue(this.value),
    };
  },
  computed: {
    inputType() {
      return (this.type === 'number' || this.type === 'tel') ? 'tel' : 'text';
    },
    hasContent() {
      return !!this.internalValue;
    },
    labelMessage() {
      if (this.isError) {
        return this.errorMessage;
      }
      return this.label;
    },
    isActive() {
      return this.isFocused || this.hasContent;
    },
    isValid() {
      return this.validationState === VALIDATION_STATES.valid;
    },
    isError() {
      return this.validationState === VALIDATION_STATES.error;
    },
  },
  methods: {
    onChangeHandler(fn) {
      const { type, internalValue, hasContent } = this;

      if (type === 'number') {
        if (hasContent) {
          return fn(Number(internalValue));
        }

        return fn(null);
      }

      return fn(internalValue);
    },
  },
  update() {
    this.internalValue = this.value;
  },
};
